export let isProductBonusEnabled = false;

// Comente a linha abaixo para desativar a bonificação no frontend.
isProductBonusEnabled = true;

export const isProductBonusEnabledForCycle = (cycleYear?: number | null): boolean =>
  isProductBonusEnabled && cycleYear != null && cycleYear >= 2027;
